import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";
import { bookingFormCommon } from '../c005-bookingform-common';
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";
require('parsley');
import 'html2canvas';
import 'MagnificPopup';


export class memberUpdateProfile {
	private updateFormprofile:any   = $('#member-personal-update');
	private updateForm:any   = $('#member-personaldetails-update');
	private updateFormpre:any   = $('#member-preference-update');
	private memberBase:any = new memberPortal();
	private bookingformcommon = new bookingFormCommon();
	private statecodes: any = [];
	private $profileCookie: String = "";
	private $contactCookie: String = "";
	private apiData: any = null;
	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): any {
		let _self = this;
		let inputElArr:any = $.makeArray(_self.updateForm.find('input[type="text"], input[type="email"]'));
		_self.$profileCookie = $("#profile_cookie").val();
		_self.$contactCookie = $("#contact_cookie").val();
		let $updateProfileFlag:any  = $('#updateProfileFlag').val();
		let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
		// show messages on the basis of cookie exist : mfaContactVerified
		if(this.getCookie(_self.$contactCookie).length === 0)  {
			$('.after-update-contact-msg').addClass('hideclass');
			$('.after-update-contact-msg').removeClass('showclass');
		} else {
			let msg = $('.after-update-contact-msg').attr('data-msg');
			let iconMsg = '<i style="font-size: 20px;margin-right: 6px;" class="fa fa-check-circle" aria-hidden="true" aria-label=""></i>' + msg;
			$('.after-update-contact-msg').html(iconMsg);
			$('.after-update-contact-msg').addClass('showclass');
			$('.after-update-contact-msg').removeClass('hideclass');
		}
		// show messages on the basis of cookie exist : mfaVerified
		if(this.getCookie('mfaVerified').length === 0 || (this.getCookie('mfaVerified').length > 0 && this.getCookie('mfaVerified')[0].value == "true"))  {
			$('.authentication-unsucessful').addClass('hideclass');
			$('.authentication-unsucessful').removeClass('showclass');
		} else {
			let msg = $('.authentication-unsucessful').attr('data-msg');
			let iconMsg = '<i style="font-size: 20px;margin-right: 6px;" class="fa fa-exclamation-triangle" aria-hidden="true" aria-label=""></i>' + msg;
			$('.authentication-unsucessful').html(iconMsg);
			$('.authentication-unsucessful').addClass('showclass');
			$('.authentication-unsucessful').removeClass('hideclass');
		}
		// on the basisi of cookies update the text of button
		$('#claim-others-update').addClass('hideclass');
		$('#claim-others-submit-edit').addClass('hideclass');
		if(this.getCookie(_self.$profileCookie).length > 0) {
			this.writeCookie({name : "profileSessionEnabled", value: true});
		}
		if(this.getCookie('profileSessionEnabled').length > 0) {
			$('#claim-others-update').addClass('showclass');
			$('#claim-others-update').removeClass('hideclass');
		} else {
			$('#claim-others-submit-edit').addClass('showclass');
			$('#claim-others-submit-edit').removeClass('hideclass');
		}
		if($updateProfileFlag == "false" && this.getCookie('profileSessionEnabled').length === 0)
		{
			// disable input fields
			let toDisableInputs:any = _self.updateForm.find('#update-profile--nationality, #update-profile--personal-address-line-1, #update-profile--personal-address-line-2, #update-profile--personal-address-line-3, #update-profile--personal-countries, #update-profile--personal-states, #update-profile--personal-address-city, #update-profile--personal-address-postcode, #update-preprofile--passport-number, #update-preprofile--passport-expiry-date, #update-profile--passport-issuing-country, #update-profile--title, #update-profile--nric-number, #update-profile--personal-address-country, #update-profile--personal-statesmob, #update-profile--gender');
		
				toDisableInputs.each((i:number, el:any) => {
					$(el).attr({
						'disabled': 'disabled'
					});
					$(el).prev().css({
						'background-color': '#eee',
						'border-top-left-radius':'10px',
						'border-top-right-radius': '10px'
					});
		
				});				
		}
		// disable input fields ALWAYS
		let toDisableInputs:any = _self.updateForm.find('#update-profile--personal-email, #update-profile--personal-phone-mobile-country-code, #update-profile--personal-phone-mobile, #update-profile--first-name, #update-profile--last-name');
			toDisableInputs.each((i:number, el:any) => {
				$(el).attr({
					'disabled': 'disabled'
				});
				$(el).prev().css({
					'background-color': '#eee',
					'border-top-left-radius':'10px',
					'border-top-right-radius': '10px'
				});

			});
		_self.memberBase.initFormTextInputs(inputElArr);
		// added to hide the submit button from co brand tab
		$('.update_tab li').click(function() {
			let self = this;
			setTimeout(() => {
				if($(self).hasClass('active')) {
					let activeTab = $(self).attr('data-active-tab-name');
					if(activeTab === 'coBrand') {
						$('.submit-wrapper').addClass('hideclass');
						$('.submit-wrapper').removeClass('showclass');
					} else {
						$('.submit-wrapper').removeClass('hideclass');
						$('.submit-wrapper').addClass('showclass');
					}
				}
			}, 100);
		})
		$('.i-pad-tap-text').click(function() {
            $(this).addClass('hideclass');
            if($(this).closest('.co-brand').find('.card-details').hasClass("hideclass")){
                $(this).closest('.co-brand').find('.card-details').removeClass('hideclass');
            }
            if($(this).closest('.co-brand').find('.card2-details').hasClass("hideclass")){
                $(this).closest('.co-brand').find('.card2-details').removeClass('hideclass');
            }
            $(this).closest('.co-brand').find('.card-details').addClass('showclass');
            $(this).closest('.co-brand').find('.card2-details').addClass('showclass');
		});
		$('.tap-text').click(function() {
            $(this).addClass('hideclass');
            if($(this).closest('.co-brand').find('.card-details').hasClass("hideclass")){
                $(this).closest('.co-brand').find('.card-details').removeClass('hideclass');
            }
            if($(this).closest('.co-brand').find('.card2-details').hasClass("hideclass")){
                $(this).closest('.co-brand').find('.card2-details').removeClass('hideclass');
            }
            $(this).closest('.co-brand').find('.card-details').addClass('showclass');
            $(this).closest('.co-brand').find('.card2-details').addClass('showclass');
		});
		$('.click-text').click(function() {
            $(this).addClass('hideclass');
            if($(this).closest('.co-brand').find('.card-details').hasClass("hideclass")){
                $(this).closest('.co-brand').find('.card-details').removeClass('hideclass');
            }
            if($(this).closest('.co-brand').find('.card2-details').hasClass("hideclass")){
                $(this).closest('.co-brand').find('.card2-details').removeClass('hideclass');
            }
            $(this).closest('.co-brand').find('.card-details').addClass('showclass');
            $(this).closest('.co-brand').find('.card2-details').addClass('showclass');
		});
		$('.contact-edit-btn').click(function(event: any) {
			event.preventDefault();
			let redirectURL = $(this).attr('data-redirectUrl');
			console.log(redirectURL);
			window.location.href = redirectURL;
		});
		$('#claim-others-submit-edit').click(function(event: any) {
			event.preventDefault();
			let url = $(this).attr('data-url-target');
			console.log(url);
			window.location.href = url;
		});
		$('a[data-toggle="pill"]').on('shown.bs.tab', function () {
			if($(this).attr('href') === "#lcp--profile--update" || $(this).attr('href') === "#co-brand_partners") {
				$('.submit-wrapper').addClass('hideclass');
				$('.submit-wrapper').removeClass('showclass');
			} else {
				$('.submit-wrapper').addClass('showclass');
				$('.submit-wrapper').removeClass('hideclass');
			}
		})
	}
	getCookie(cookieName: any) {
		let cookies:any  = [];
		document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookies.push({key: key.trim(), value : value});
		});
		let ck = cookies.filter((c: any) => {
			return cookieName === c.key;
		})
		return ck;
	}
	writeCookie(cookie: any) {
		var now = new Date();
		var minutes = 30;
		now.setTime(now.getTime() + (minutes * 60 * 1000));
		document.cookie=cookie.name + "=" + cookie.value;
		document.cookie = "expires=" + now.toUTCString() + ";"
 	}
	/**
	 * [initSelectizeInputs description]
	 * @return {any} [description]
	 */
	initSelectizeInputs(): any {
		let _self = this;
		var titleInput = $('#update-profile--title');
		var getTitleOptions = $.Deferred();
		let titlecodeurl:string = '';
		// if (window.location.hostname === 'localhost' && window.location.port == "5000") {
		// 	titlecodeurl = '/dummy-data/TitleCode.json';
		// }
		// else {
		// 	titlecodeurl = '/content/dam/mas/json/TitleCode.json';
		// }
		titlecodeurl = '/content/dam/mas/json/TitleCodeLCP.json';
		$.get(titlecodeurl)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			for (var i = 0; i < data.Titles.length; i++) {
				// listItems += "<option value='" + data.Titles[i].Code + "'>" + data.Titles[i].Name + "</option>";
				listItems += '<option value="'+data.Titles[i].Code + '">' + data.Titles[i].Name + '</option>';
			}
			getTitleOptions.resolve(listItems);
			
		})
		.fail((error:any) => {
			getTitleOptions.reject(error);
		});

		var countryInput = $('.update-profile--personal-address-country select');		

		var getCountryOptions = $.Deferred();
		let countrycodeurl:string ='';
		// if (window.location.hostname === 'localhost' && window.location.port == "5000") {
		// 	countrycodeurl = '/dummy-data/countrycode.json';
		// }
		// else {
		// 	countrycodeurl = '/content/dam/mas/json/countrycode.json';
		// }
		countrycodeurl = '/content/dam/mas/json/countrycode.json';
		$.get(countrycodeurl)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			for (var i = 0; i < data.Countries.length; i++) {
				listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
			}
			getCountryOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getCountryOptions.reject(error);
		});
		var newcountrylist = $('#update-profile--personal-countries');
		var nationalityInput = $('#update-profile--nationality');
		var businessCountryInput = $('#update-profile--business-address-country');
		var passportissuing=$('#update-profile--update-issuing--country');
		var preferencecountry=$('#update-profile--preference-address-country');
		var countrylistmob=$('#update-profile--personal-address-country');
		var passportissuing=$('#update-profile--passport-issuing-country')
		var getNationalityOptions = $.Deferred();
		$.get(countrycodeurl)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}			
			for (var i = 0; i < data.Countries.length; i++) {
				listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
			}
			getNationalityOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getNationalityOptions.reject(error);
		});
// new country and state code 
		let newcountrycodeurl:string ='';
		if (window.location.hostname === 'localhost' && window.location.port == "5000") {
		newcountrycodeurl = '/dummy-data/updateState.json';
		}
		else {
		 	newcountrycodeurl =  '/content/dam/mas/json/statecodes.json'
		}
		var getnewCountryOptions = $.Deferred();
		$.get(newcountrycodeurl)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			 localStorage.setItem("lcp-search", JSON.stringify(data));		
			for (var i = 0; i < data.CountriesList.length; i++) {
				listItems += "<option value='" + data.CountriesList[i].CountryCode + "'>" + data.CountriesList[i].CountryName + "</option>";
			}
			getnewCountryOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getnewCountryOptions.reject(error);
		});
		var stateCodeInput = $('#update-profile--personal-states');	
		var stateCodeInputmob = $('#update-profile--personal-statesmob');		
		var getStateCodeOptions = $.Deferred();
		let stateCodeUrl: string = '';
		$.get(newcountrycodeurl)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost') {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			 _self.statecodes = data
			 _self.handleCountryStates();
			 _self.handleCountryStatesmob();
			for (var i = 0; i < data.CountriesList.length; i++) {
				for(var j = 0; j< data.CountriesList[i].StatesList.length; j++){
					if(data.CountriesList[i].StatesList[j].StateCode!='NULL'){
						listItems += "<option value='" + data.CountriesList[i].StatesList[j].StateCode + "'>" + data.CountriesList[i].StatesList[j].StateName+ "</option>";
					}
				}
			}
				getStateCodeOptions.resolve(listItems);

		})
		.fail((error:any) => {
			getStateCodeOptions.reject(error);
		});
		
		$.when(getTitleOptions, getCountryOptions,getnewCountryOptions,getStateCodeOptions).done(function(titleOptions:any, countryOptions:any,newcountry:any,stateOptions:any) {
			titleInput.html(titleOptions);
			countryInput.html(countryOptions);
			nationalityInput.html(countryOptions);
			passportissuing.html(countryOptions);
			preferencecountry.html(countryOptions);
			businessCountryInput.html(countryOptions);
			newcountrylist.html(newcountry);
			countrylistmob.html(newcountry);
			passportissuing.html(newcountry);
			stateCodeInput.html(stateOptions);
			stateCodeInputmob.html(stateCodeInputmob);
			var inputSelectArr = $.makeArray(_self.updateFormprofile.find('select'));
			_self.memberBase.initSelectizeInputs(inputSelectArr);
			_self.removeElementsforResponsiveness();
			_self.handleGender();
			
		});

	}
	PreinitSelectizeInputs(): any {
		let _self = this;
		var dietryInput = $('#update-profile--dietry-requirement');
		var getdietryOptions = $.Deferred();
		let dietrycodeurl1:string = '';
		/*if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			titlecodeurl = '/dummy-data/TitleCode.json';
		}
		else {
			titlecodeurl = '/content/dam/mas/json/TitleCode.json';
		}*/
		dietrycodeurl1 = '/content/dam/mas/json/Dietry.json';
		$.get(dietrycodeurl1)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			for (var i = 0; i < data.Dietry.length; i++) {
				listItems += "<option value='" + data.Dietry[i].Code + "'>" + data.Dietry[i].Name + "</option>";
			}
			getdietryOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getdietryOptions.reject(error);
		});
		var insuranceInput = $('#update-profile--insurance-purchase');
		var getinsuranceOptions = $.Deferred();
		let insurancecodeurl:string = '';
		/*if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			titlecodeurl = '/dummy-data/TitleCode.json';
		}
		else {
			titlecodeurl = '/content/dam/mas/json/TitleCode.json';
		}*/
		insurancecodeurl = '/content/dam/mas/json/Medicalcare.json';
		$.get(insurancecodeurl)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			for (var i = 0; i < data.Medicalcare.length; i++) {
				listItems += "<option value='" + data.Medicalcare[i].Code + "'>" + data.Medicalcare[i].Name + "</option>";
			}
			getinsuranceOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getinsuranceOptions.reject(error);
		});

		var countryInput = $('.update-profile--personal-address-country select');		

		//
		var seatingInput = $('#update-profile--prefered-seating');
		var getseatingOptions = $.Deferred();
		let seatingcodeurl:string = '';
		// /*if (window.location.hostname === 'localhost' && window.location.port == "5000") {
		// 	titlecodeurl = '/dummy-data/TitleCode.json';
		// }
		// else {
		// 	titlecodeurl = '/content/dam/mas/json/TitleCode.json';
		// }*/
		seatingcodeurl = '/content/dam/mas/json/Seating.json';
		$.get(seatingcodeurl)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			for (var i = 0; i < data.Seating.length; i++) {
				listItems += "<option value='" + data.Seating[i].Code + "'>" + data.Seating[i].Name + "</option>";
			}
			getseatingOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getseatingOptions.reject(error);
		});

		var countryInput = $('.update-profile--personal-address-country select');		

		var getCountryOptions = $.Deferred();
		let countrycodeurl:string ='';
		/*if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			countrycodeurl = '/dummy-data/countrycode.json';
		}
		else {
			countrycodeurl = '/content/dam/mas/json/countrycode.json';
		}*/
		countrycodeurl = '/content/dam/mas/json/countrycode.json';
		$.get(countrycodeurl)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			for (var i = 0; i < data.Countries.length; i++) {
				listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
			}
			getCountryOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getCountryOptions.reject(error);
		});

		let newcountrycodeurl:string ='';
		var newcountrylist = $('#update-profile--personal-prefcountries');
		if (window.location.hostname === 'localhost' && window.location.port == "5000") {
		newcountrycodeurl = '/dummy-data/updateState.json';
		}
		else {
		 	newcountrycodeurl = '/content/dam/mas/json/statecodes.json';
		}
		var getnewCountryOptions = $.Deferred();
		$.get(newcountrycodeurl)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			 localStorage.setItem("lcp-search", JSON.stringify(data));		
			for (var i = 0; i < data.CountriesList.length; i++) {
				listItems += "<option value='" + data.CountriesList[i].CountryCode + "'>" + data.CountriesList[i].CountryName + "</option>";
			}
			getnewCountryOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getnewCountryOptions.reject(error);
		});
		$.when(getseatingOptions, getCountryOptions,getdietryOptions,getinsuranceOptions,getnewCountryOptions).done(function(seatOptions:any, countryOptions:any,dietryOptions:any,insuranceOptions:any,newcountryOptions:any) {
			seatingInput.html(seatOptions);
			dietryInput.html(dietryOptions);
			insuranceInput.html(insuranceOptions);
			countryInput.html(countryOptions);
			newcountrylist.html(newcountryOptions);
			var inputSelectArr = $.makeArray(_self.updateFormpre.find('select'));
			_self.memberBase.initSelectizeInputs(inputSelectArr);
			_self.removeElementsforResponsiveness();
		});

	}
	removeElementsforResponsiveness(): any {
		$('#update-profile--nationality').on('change', function() {
			if($('#update-profile--nationality').val()=='MY')
			{
				$('.update-profile--nric-number').removeClass('hide')
				$('#update-profile--nric-number').attr({
					'required': 'required',
					'data-parsley-length':'[12, 12]',
					'data-parsley-type':'digits'
				});
			}
			else
			{
				$('.update-profile--nric-number').addClass('hide');
				$('#update-profile--nric-number').val('');
				$('#update-profile--nric-number').removeAttr('required');​​​​​		
			}
		  })
		let $divaddressitem: any = $('.update-address-item-desk');
		let $divaddressitemmobile: any = $('.update-address-item-mob');
		let $divinterestitem: any = $('.update-interest-item-desk');
		let $divinterestitemmobile: any = $('.update-interest-item-mob');
		let _self = this;
		if (window.innerWidth < 1000)  {
			$divaddressitem.detach();
			$divinterestitem.detach();
			$divaddressitemmobile.appendTo('.update-profile-add-mob');
			$divinterestitemmobile.appendTo('.update-profile-int-mob');
		} else {
			$divaddressitemmobile.detach();
			$divinterestitemmobile.detach();
			$divaddressitem.appendTo('.update-profile-add-desk');
			$divinterestitem.appendTo('.update-profile-int-desk');
		}
		window.addEventListener("resize", function () {
			if (window.innerWidth < 1000)  {
				$divaddressitem.detach();
				$divinterestitem.detach();
				$divaddressitemmobile.appendTo('.update-profile-add-mob');
				$divinterestitemmobile.appendTo('.update-profile-int-mob');				
			} else {
				$divaddressitemmobile.detach();
				$divinterestitemmobile.detach();
				$divaddressitem.appendTo('.update-profile-add-desk');
				$divinterestitem.appendTo('.update-profile-int-desk');				
			}
		})
	}

	populateFlightBookingTitle(): any {
		let $titleselect: any = $('#update-profile--title');
		let $genderselect: any = $('#update-profile--gender');
		let $bookingtitleinput: any = $('#update-profile--booktitle');		
		let $titleselectvalue = $titleselect.val();
		let $genderselectvalue = $genderselect.val();
		if ($genderselectvalue !== '' && $titleselectvalue !== '') {
			if ($genderselectvalue === 'M') {
				$bookingtitleinput.val('Mr');
			} else if ($genderselectvalue === 'F') {
				if ($titleselectvalue !== 'Mrs') {
					$bookingtitleinput.val('Miss');
				}
			}
		}
		if ($titleselectvalue !== '') {
			if ($titleselectvalue === 'Mrs') {
				$bookingtitleinput.val('Mrs');
			}
		}
	}

	/**
	 * [initDatepickerInputs description]
	 * @return {any} [description]
	 */
	initDatepickerInputs(): any {
		let _self = this;
		let inputDateArr   = $('#update-profile--date-of-birth');
		let inputExpiryArr   = $('#update-profile--passport-expiry-date');
		let inputpreExpiryArr   = $('#update-preprofile--passport-expiry-date');
		//let inputElArr:any = $.makeArray(inputDateArr,inputExpiryArr);
		
		let minDate = new Date((new Date().getFullYear() - 100).toString());
		let maxDate = new Date((new Date().getTime() - 1000*60*60*24*365*2));
		let expiryminDate = new Date((new Date().getFullYear() - 100).toString());
		let expirymaxDate = new Date((new Date().getFullYear() + 100).toString());
		let $updateProfileFlag:any   		= $('#updateProfileFlag').val();
		
		if($updateProfileFlag=="false")
		{
			let toDisableInputs:any = _self.updateForm.find('#update-profile--date-of-birth');
			
					toDisableInputs.each((i:number, el:any) => {
						$(el).attr({
							'disabled': 'disabled'
						});
						$(el).prev().css({
							'background-color': '#eee',
							'border-top-left-radius':'10px',
							'border-top-right-radius': '10px'
						});
					});					
		}

		_self.memberBase.initDatepickerInputs(inputDateArr, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr, expiryminDate, expirymaxDate);
		_self.memberBase.initDatepickerInputs(inputpreExpiryArr, expiryminDate, expirymaxDate);		
	}

	initCheckboxes(): any {


		$(document).on('click', '.update--lcp--profile--consents--add', function () {
			//alert("click...");
			//var id = $(this).attr('id');
			//alert("checkbox id"+id);
			//if ($('#' + id).is(':checked')) {
				if(this.checked) {
				//alert($(this).val()+ ' is checked');
				$(this).parent().addClass('ischecked');
			}
			else{
				//alert("removed check box");
				$(this).parent().removeClass('ischecked');
			}
		});

		/*$('input[type=checkbox]').each(function () {
			$(this).on('click', (e:any) => {
				if(this.checked) {
					$(this).parent().addClass('ischecked');
				}
				else {
					$(this).parent().removeClass('ischecked');
				}
			});
		});*/
	}

	/**
	 * [initPhoneInput description]
	 * @return {any} [description]
	 */
	initPhoneInput(): any {
		let _self = this;

		let phoneCodeInputMobile   = $('#update-profile--personal-phone-mobile-country-code');

		let getPhoneOptions = $.Deferred();
		let phonecodeurl:string = '';
		/*if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			phonecodeurl = '/dummy-data/PhoneCode.json';
		}
		else {
			phonecodeurl = '/content/dam/mas/json/PhoneCode.json';
		}*/
		phonecodeurl = '/content/dam/mas/json/PhoneCode.json';
		$.get(phonecodeurl)
		.done((data:any) => {
			let listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			for (let i = 0; i < data.Phonecodes.length; i++) {
				listItems += "<option value='" + data.Phonecodes[i].Code + "'>" + data.Phonecodes[i].Code +"</option>";
			}
			getPhoneOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getPhoneOptions.reject(error);
		});

		$.when(getPhoneOptions).done(
			function(titleOptions:any) {
				phoneCodeInputMobile.html(titleOptions);

				let inputElArr = $.makeArray(_self.updateForm.find('.phoneinput'));
				_self.memberBase.initPhoneInput(inputElArr);
			});

		// change phone number field validation message
		let phoneNumberFields = _self.updateForm.find('.phoneinput input[type="tel"]');

		phoneNumberFields.each((i:number, el:any) => {
			$(el).attr({
				'data-parsley-type-message': 'This value should be a valid number.'
			});
		});
	}

	/**
	 * Initiate business address inputs when `add business address` button
	 * is clicked
	 * - hide button after clicking as well.
	 * @return {any} [description]
	 */
	initBusinessAddress(): any {
		let _self = this;
		let addBtndesk = _self.updateForm.find('.consents--add--desk');
		let addBtnmob = _self.updateForm.find('.consents--add--mob');
		//let addcheckbox_mob = _self.updateForm.find('#update-profile--subscription-preferences--mob');
		let addcheckbox_desk = _self.updateForm.find('.update-profile--subscription-preferences');
		addBtndesk.on('click', function(e:any){
			//alert("please come...");
			let agreesToselect:any;
			let agreesFromoselect:any;
			let agreesViaselect:any;
			
				agreesToselect = _self.updateForm.find('.update-profile--agreesto').val();
				agreesFromoselect = _self.updateForm.find('.update-profile--agreesfrom').val();
				agreesViaselect = _self.updateForm.find('.update-profile--agreesvia').val();
			
			
			
			/*let agreesToselect = $(".update-profile--agreesto").val();
			let agreesFromoselect = $(".update-profile--agreesfrom").val();
			let agreesViaselect = $(".update-profile--agreesvia").val();*/
			//alert("agreesToselect>>"+agreesToselect+"agreesFromoselect>>"+agreesFromoselect+"$agreesViaoselect>>"+agreesViaselect);
			var id=agreesViaselect+"--"+agreesFromoselect+"--"+agreesToselect;
			var mob_id=agreesViaselect+"--"+agreesFromoselect+"--"+agreesToselect+"-mob";
			var msg ="I Agree to receive "+agreesViaselect+" for "+agreesToselect+" From "+agreesFromoselect+" ";
			var listVals=new Array;
			var result;
			if($('.update-profile--subscription-preferences').find('.update--lcp--profile--consents--add').length !== 0)
			{
				//alert("1st if...");
				$(".update--lcp--profile--consents--add").each(function() {
					//var existid = $(this).attr('id');
					var existid = $(this).val();
						//alert("existid>"+existid);
						listVals.push(existid);
				});
				if(listVals.length>0)
				{
					for(var i=0; i<listVals.length; i++){
						var name = listVals[i];
						if(name == id){
						  result = 'Exist';
						  break;
						}
					  }
					  if(result=='Exist'){
						//alert("error...");
					  }else{
						//addcheckbox_mob.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="profile-subscribe--email-enrich" aria-label="Receive emails from Enrich" id="'+mob_id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--email-enrich">'+msg+'</label></label></div></div>');
						addcheckbox_desk.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="'+id+'" aria-label="Receive emails from Enrich" id="'+id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--consents">'+msg+'</label></label></div></div>');
					  }
				}
			}else{
				//addcheckbox_mob.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="profile-subscribe--email-enrich" aria-label="Receive emails from Enrich" id="'+mob_id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--email-enrich">'+msg+'</label></label></div></div>');
				addcheckbox_desk.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="'+id+'" aria-label="Receive emails from Enrich" id="'+id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--consents">'+msg+'</label></label></div></div>');
			}
		});
		addBtnmob.on('click', function(e:any){
			//alert("please come...");
			let agreesToselectMob:any;
			let agreesFromoselectMob:any;
			let agreesViaselectMob:any;
			
				agreesToselectMob = _self.updateForm.find('.update-profile--agreesto--mob').val();
				agreesFromoselectMob = _self.updateForm.find('.update-profile--agreesfrom--mob').val();
				agreesViaselectMob = _self.updateForm.find('.update-profile--agreesvia--mob').val();
			
			
			
			/*let agreesToselect = $(".update-profile--agreesto").val();
			let agreesFromoselect = $(".update-profile--agreesfrom").val();
			let agreesViaselect = $(".update-profile--agreesvia").val();*/
			//alert("agreesToselect>>"+agreesToselect+"agreesFromoselect>>"+agreesFromoselect+"$agreesViaoselect>>"+agreesViaselect);
			var id=agreesViaselectMob+"--"+agreesFromoselectMob+"--"+agreesToselectMob;
			var mob_id=agreesViaselectMob+"--"+agreesFromoselectMob+"--"+agreesToselectMob+"-mob";
			var msg ="I Agree to receive "+agreesViaselectMob+" for "+agreesToselectMob+" From "+agreesFromoselectMob+" ";
			var listVals=new Array;
			var result;
			if($('.update-profile--subscription-preferences').find('.update--lcp--profile--consents--add').length !== 0)
			{
				//alert("1st if...");
				$(".update--lcp--profile--consents--add").each(function() {
					//var existid = $(this).attr('id');
					var existid = $(this).val();
						//alert("existid>"+existid);
						listVals.push(existid);
				});
				if(listVals.length>0)
				{
					for(var i=0; i<listVals.length; i++){
						var name = listVals[i];
						if(name == id){
						  result = 'Exist';
						  break;
						}
					  }
					  if(result=='Exist'){
						//alert("error...");
					  }else{
						//addcheckbox_mob.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="profile-subscribe--email-enrich" aria-label="Receive emails from Enrich" id="'+mob_id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--email-enrich">'+msg+'</label></label></div></div>');
						addcheckbox_desk.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="'+id+'" aria-label="Receive emails from Enrich" id="'+id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--consents">'+msg+'</label></label></div></div>');
					  }
				}
			}else{
				//addcheckbox_mob.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="profile-subscribe--email-enrich" aria-label="Receive emails from Enrich" id="'+mob_id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--email-enrich">'+msg+'</label></label></div></div>');
				addcheckbox_desk.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="'+id+'" aria-label="Receive emails from Enrich" id="'+id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--consents">'+msg+'</label></label></div></div>');
			}
		});
	}

	validateForm(): any {
		let _self = this;

		_self.memberBase.validateForm(_self.updateForm, function(validation: any) {
			// all your custom validation here
			// let intCheckbox = _self.updateForm.find('.update-profile--interest-preferences input[type="checkbox"]');

			// intCheckbox.each(function(i:number, el:any){
			// 	$(el).attr({
			// 		'data-parsley-mincheck': 3,
			// 		'required': 'required'
			// 	});
			// });

			// let festRadio = _self.updateForm.find('.update-profile--festival-preferences input[type="radio"]');

			// festRadio.each(function(i:number, el:any){
			// 	$(el).attr({
			// 		'required': 'required'
			// 	});
			// });


			//Alpha fields
			// let alphaInputs = _self.updateForm.find('#update-profile--personal-address-line-1, #update-profile--personal-address-line-2, #update-profile--personal-address-line-3');
			// alphaInputs.attr({
			// 	'data-parsley-pattern': '^[a-zA-Z0-9 ]+$'
			// });

			// MESU-194: remove field, no need to confirm
			// confirm email validation
			// let emailId:string = 'update-profile--personal-email';
			// let confirmEmail:any = _self.updateForm.find('#update-profile--personal-email-confirm');
			// confirmEmail.attr('data-parsley-equalto', '#'+emailId);

			// postal code: only alphanumeric
			let postalCodeInput:any = $('#update-profile--personal-address-postcode');
			postalCodeInput.attr('data-parsley-type', 'alphanum');

			let nricInput:any = $('#update-profile--nric-number');
			if($('#update-profile--nric-number').is(':visible')) {
				nricInput.attr('data-parsley-pattern', '^[a-zA-Z0-9 ]+$');				
			}
			// city, state: only alphanumeric
			let cityStateInputs:any = $('#update-profile--personal-address-state');
			cityStateInputs.each((i:number, el:any) => {
				$(el).attr('data-parsley-pattern', '^[a-zA-Z ]+$');
			});

			// phone number: integer only
			let phoneInputs:any = $('#update-profile--personal-phone-mobile');
			phoneInputs.each((i:number, el:any) => {
				$(el).attr('data-parsley-type', 'integer');
			});

		}, (validation:any, formData:any, htmlFormData:any) => {
			// on success function

				let submitBtn = _self.updateForm.find('#claim-others-update');
				let successMsg = $('#update-profile-success');

				$('html, body').animate({
					'scrollTop': 0
				}, 500, () => {
					submitBtn.fadeOut();
					successMsg.fadeIn();
				});

				let disabledInputs:any = _self.updateForm.find('#update-profile--first-name, #update-profile--last-name, #update-profile--date-of-birth, #update-profile--personal-email, #update-profile--booktitle');

				disabledInputs.each((i:number, el:any) => {
					let $input = $(el);

					formData.push({
						name: $input.attr('name'),
						value: $input.val()
					});
				});


		});
	}

	initPrintSaveCardLCP():any {
		let _self = this;
		let printBtn = _self.updateForm.find('#members-print-card--lcp');
		let saveBtn = _self.updateForm.find('#members-save-card--lcp');
		let cardImage = _self.updateForm.find('.members--card-image');
		let cardAspectRatio = 273/137;

		printBtn.on('click', (e:any) => {
			e.preventDefault();
			e.stopPropagation();

			html2canvas(cardImage[0], {
				onrendered: function(canvas:any) {
					let nW:any = window.open('','','width=600,height=400');
					nW.document.write('<img src="'+canvas.toDataURL()+'"/>');
					nW.focus();
					setTimeout(() => {
						nW.print();
						nW.close();
					}, 600);
				}
			});
		});

		saveBtn.on('click', (e:any) => {
			e.preventDefault();
			e.stopPropagation();
			let populateurl = $('[data-get-updateprofile-url]').attr('data-get-updateprofile-url');
			let nameOncard=$('#prefrence--card-name').val();
			$('.card--username').html(nameOncard);
			var data = {
			'action': 'saveBtn',
			'nameOnCard':nameOncard
			};
			_self.bookingformcommon.preloader();
			$.ajax({
				type: 'POST',
				url: populateurl,
				data: data,
				success: function(msg:any) {
					_self.redirectUser(msg);
					_self.bookingformcommon.preloaderClose();
					if (msg == "OK" || msg == "00" || msg == "03") {
						$('html, body').animate({
							'scrollTop': 0
						}, 500, function() {
							$("#update-profile-success").fadeIn();
						});
					}
				},
				error: function(error:any) {
					_self.bookingformcommon.preloaderClose();
					if(error.responseText == "OK"){
						$('html, body').animate({
							'scrollTop': 0
						}, 500, function() {
							$("#update-profile-success").fadeIn();
						});
					}
				}
			});
			html2canvas(cardImage[0], {
				onrendered: function(canvas:any) {
					_self.updateForm
					.append('<a class="hidden" id="temp-card-image-for-dl" href="'+canvas.toDataURL()+'" download="member-card.png">Download</a>');

					let tempDlBtn = $('#temp-card-image-for-dl');

					tempDlBtn[0].click();
				}
			});
		});
	}
	/**
	 * populate input fields on page load
	 * @return {any} [description]
	 */
	populateFields(): any {
		let _self = this;
		let populateurl = $('[data-get-updateprofile-url]').attr('data-get-updateprofile-url');
		var data = {
			'action': 'fetch'
		};
		$.ajax({
			type: 'POST',
			url:populateurl,
			data: data,
			success: function(msg:any) {
				//_self.redirectUser(msg);
				if(msg != "{}")
				{
					let inputFields = {
						'title': 		 					'update-profile--title',
						'firstName': 	 				'update-profile--first-name',
						'lastName': 	 				'update-profile--last-name',
						'birthDate': 	 				'update-profile--date-of-birth',
						'gender': 		 				'update-profile--gender',
						'nationality': 		 		'update-profile--nationality',
						'nricnumber': 				'update-profile--nric-number',
						'passportnumber': 		'update-profile--passport-number',
						'passportExpiryDate':   'update-profile--passport-expiry-date',
						'prepassportnumber': 		'update-preprofile--passport-number',
						'prepassportExpiryDate':   'update-preprofile--passport-expiry-date',
						'contactPhoneMobile': 'update-profile--personal-phone-mobile',
						'contactCCodeMobile': 'update-profile--personal-phone-mobile-country-code',
						'contactEmail':  			'update-profile--personal-email',
						'addressLine1': 			'update-profile--personal-address-line-1',
						'addressLine2': 			'update-profile--personal-address-line-2',
						'addressLine3': 			'update-profile--personal-address-line-3',
						'addressCountry': 		'update-profile--personal-address-country',
						'addressCity': 				'update-profile--personal-address-city',
						'addressPostCode': 		'update-profile--personal-address-postcode',
						'subsEmail': 					'profile-subscribe--email-enrich',
						'subsEmailPartners': 	'profile-subscribe--email-enrich-partners',
						'subsSms': 					'profile-subscribe--sms-enrich',
						'subsSmsPartners': 	'profile-subscribe--sms-enrich-partners',
						'subsPhone': 		'profile-subscribe--phone-enrich',
						'subsPhonePartners': 		'profile-subscribe--phone-enrich-partners',
						'subsWhatsApp': 					'profile-subscribe--whatsApp-enrich',
						'subsWhatsAppPartners': 	'profile-subscribe--whatsApp-partners',
						'subsPushNootification': 		'profile-subscribe--push_notifcation-enrich',
						'subsPushNootificationPartners': 		'profile-subscribe--push_notifcation-partners',
						'interestBusiness':'update-profile--interest-business',
						"interestEntertainment": "update-profile--interest-entertainment",
						"interestFamily":"update-profile--interest-family",
						"interestFitness": "update-profile--interest-welness",
						"interestFood": "update-profile--interest-food",
						"interestHobbies": "update-profile--interest-hobbies",
						"interestShopping": "update-profile--interest-beauty-shopping",
						"interestSports": "update-profile--interest-sport",
						"interestTech": "update-profile--interest-technology",
						"interestTravel": "update-profile--interest-travel",
						'interestBusinessmob':'update-profile--interest-businessmob',
						"interestEntertainmentmob": "update-profile--interest-entertainmentmob",
						"interestFamilymob":"update-profile--interest-familymob",
						"interestFitnessmob": "update-profile--interest-welnessmob",
						"interestFoodmob": "update-profile--interest-foodmob",
						"interestHobbiesmob": "update-profile--interest-hobbiesmob",
						"interestShoppingmob": "update-profile--interest-beauty-shoppingmob",
						"interestSportsmob": "update-profile--interest-sportmob",
						"interestTechmob": "update-profile--interest-technologymob",
						"interestTravelmob": "update-profile--interest-travelmob",
						'addressCountrypass': 'update-profile--passport-issuing-country',
						'preferedseating': 'update-profile--prefered-seating',
						'dietryRequirement': 'update-profile--dietry-requirement',
						'insurancePurchase': 'update-profile--insurance-purchase',
						'preferedCardName': 'prefrence--card-name',		
						'newcountry': 'update-profile--personal-countries',
						'newstate': 'update-profile--personal-states',
						'addressState': 'update-profile--personal-statesmob',

					}; 
					let res: any;
					if (typeof msg === 'string') {
						res = JSON.parse(msg);
						_self.apiData = res; 
					}
					else {
						res = msg;
						_self.apiData = res;
					}		
					//if (window.location.hostname === 'localhost')
					//res = msg;
					//else
					// $('#lcp_update_profile_members').addClass("data-population")
					// let statesInputSelectArr = $("#update-profile--personal-states");
					// let prefstatesInputSelectArr = $("#update-profile--personal-prefstates");
					// var getStateOptions = $.Deferred();
					// var getprefStateOptions = $.Deferred();
					// var dataList = JSON.parse(localStorage['lcp-search']);        
					// var listItems = "<option value=''> </option>";  
					// for(var i = 0; i < dataList.CountriesList.length; i++)
					// {
					//   if(dataList.CountriesList[i].CountryCode == res.homeCountry)
					//   {
					// 	$("#update-profile--personal-states").html('<option value="000">-Select State-</option>');
					// 	 $.each(dataList.CountriesList[i].StatesList, function (index:any, value:any) {
					// 		if(dataList.CountriesList[i].StatesList == res.homeState)
					// 		{

					// 			listItems += "<option selected value='" + value.StateCode + "'>" + value.StateName + "</option>";

					// 		}
					// 	else{
					// 			listItems += "<option value='" + value.StateCode + "'>" + value.StateName + "</option>";
					// 	}
					// 	});
					// 	getStateOptions.resolve(listItems);
					//   }
					//   if( res.homeCountry=='undefined' || res.homeCountry==null ){
					// 	$("#update-profile--personal-states").html('<option value="000">-Select State-</option>');
					// 	$.each(dataList.CountriesList[i].StatesList, function (index:any, value:any) {
						  
					// 		   listItems += "<option value='" + value.StateCode + "'>" + value.StateName + "</option>";
					   
					//    });
					//    getStateOptions.resolve(listItems);
					//   }
					// }
					// for(var i = 0; i < dataList.CountriesList.length; i++)
					// {
					  
					// 	$("#update-profile--personal-states").html('<option value="000">-Select State-</option>');	
					// 	for (let j = 0; j < dataList.CountriesList[i].StatesList.length; j++) {
					// 			listItems += "<option value='" + dataList.CountriesList[i].StatesList[j].StateCode + "'>" + dataList.CountriesList[i].StatesList[j].StateName + "</option>";
					// 	}
					// 	getprefStateOptions.resolve(listItems);
					  
					// }

					// $.when(getStateOptions,getprefStateOptions).done(function(titleOptions:any,prefstates:any) {
					// 	statesInputSelectArr.html(titleOptions);
					// 	prefstatesInputSelectArr.html(prefstates);
					// 	var inputSelectArr = $.makeArray(statesInputSelectArr,prefstatesInputSelectArr);
					// 	_self.initSelectizeInputsnew(inputSelectArr);
					// });

					$(".progress").each(function(){
						$('.circle_progreesive span').html(res.profilepercentage)
						var $bar = $(this).find(".bar");
						var $val = $(this).find("span");
						var perc = parseInt( $val.text(), 10);
					  
						$({p:0}).animate({p:perc}, {
						  duration: 3000,
						  easing: "swing",
						  step: function(p:any) {
							$bar.css({
							  transform: "rotate("+ (45+(p*1.8)) +"deg)", // 100%=180° so: ° = % * 1.8
							  // 45 is to add the needed rotation to have the green borders at the bottom
							});
							$val.text(p|0);
						  }
						});
					  });
					  $('#members--enrich-status-lcp .progress-bar').attr("data-percent",res.profilepercentage);	
					  _self.initProgressBarElem();		 
					  $('.card--username').html(res.cardUsername);
					  $('.card--number').html(res.cardNumber);
					  $('.card--expiry').html(res.cardExpiry);
					  var cardtype=res.cardType;
					  $('.members--card-image').find('#'+cardtype).removeClass('hide')
					let title = res.title;
					if(title.includes("'")) {
						title = title.replace("'", "''");
					}
					let data = {
						'title': 							title,
						'firstName': 					res.firstName,
						'lastName': 					res.lastName,
						'birthDate': 					res.dob,
						'gender': 						res.gender,
						'nationality': 				res.nationality,
						'nricnumber': 				res.nricnumber,
						'passportnumber': 		res.passportNumber,
						'passportExpiryDate':   res.passportExpiryDate,
						'prepassportnumber': 		res.passportNumber,
						'prepassportExpiryDate':   res.passportExpiryDate,
						'contactPhoneMobile': res.mobileNumber,
						'contactCCodeMobile': res.countryCodeMobile,
						'contactEmail': 			res.email,
						'addressLine1': 			res.homeAddress1,
						'addressLine2': 			res.homeAddress2,
						'addressLine3': 			res.homeAddress3,
						'addressCountry': 		res.homeCountry,
						'addressCity': 				res.homeCity,
						'addressState': 			res.homeState,
						'addressPostCode': 		res.homePostCode,
						'subsEmail': 					res.emailFromEnrich,
						'subsEmailPartners': 	res.emailFromEnrichPartners,
						'subsSms': 					res.smsEnrich,
						'subsSmsPartners': 	res.smsEnrichPartner,
						'subsPhone': 		res.phoneEnrich,
						'subsPhonePartners': 		res.phoneEnrichPartner,
						'subsWhatsApp': 					res.whatsAppFrmEnrich,
						'subsWhatsAppPartners': 	res.whatsAppFrmPartner,
						'subsPushNootification': 		res.pushNotificationFrmEnrich,
						'subsPushNootificationPartners': 		res.pushNotificationFrmPartner,
						"interestBusiness": res.interestBusiness,
						"interestEntertainment": res.interestEntertainment,
						"interestFamily":res.interestFamily,
						"interestFitness": res.interestFitness,
						"interestFood": res.interestFood,
						"interestHobbies": res.interestHobbies,
						"interestShopping": res.interestShopping,
						"interestSports": res.interestSports,
						"interestTech": res.interestTech,
						"interestTravel": res.interestTravel,
						'interestBusinessmob':res.interestBusiness,
						"interestEntertainmentmob":res.interestEntertainment,
						"interestFamilymob":res.interestFamily,
						"interestFitnessmob": res.interestFitness,
						"interestFoodmob": res.interestFood,
						"interestHobbiesmob": res.interestHobbies,
						"interestShoppingmob": res.interestShopping,
						"interestSportsmob":res.interestSports,
						"interestTechmob":res.interestTech,
						"interestTravelmob":res.interestTravel,
						'businessJobTitle':res.jobTitle,
						'department':res.department,
						'company':res.company,
						'addressCountrypass':res.passportCountry,
						'preferedseating': res.preferedSeating,
						'dietryRequirement': res.dietryRequirement,
						'insurancePurchase': res.insurancePurchase,
						'preferedCardName': res.cardUsername,
						'newstate': res.homeState,
						'newcountry':res.homeCountry,
					}
	
					$.each(inputFields, (param:any, inputId:any) => {
						// console.log(param, inputId, data[param]);
	
						let input:any = $('#'+inputId);
	
						// handle select inputs
						if (input.is('select') && input[0].selectize) {
							input[0].selectize.setValue(data[param]);
						} else if (input.is('[type="checkbox"]')) {
						// handle checkbox inputs
							if (data[param]=='T') {
								input.prop('checked', 'checked');
								input.parent().addClass('ischecked');
							}
						} else if (input.hasClass('datepicker')) {
							input.datepicker('setDate', data[param]);
							// handle date inputs
						} else {
							// handle all other inputs
							input.val(data[param]);
						}
	
						// handle group interests/festival inputs
						if (!input.length) {
							let inputGrp:any = $('[name="'+inputId+'"]');
							// console.log(inputGrp.length, inputGrp);
	
							$.each(inputGrp, (i:number, inputEl:any) => {
								if ($.inArray(inputEl.value, data[param]) >= 0) {
									$(inputEl).prop('checked', 'checked');
									$(inputEl).parent().addClass('ischecked');
								}
								$(inputEl)
							});
						}
	
						input.blur();
						// manually apply state to elements if not added by blur
						input.parent().find('label').addClass('input-filled');
						input.addClass('input-focused');
					});	
					$('#lcp_update_profile_members').removeClass("data-population")
					/*if(res.fisttimeUser=='true')
					{
						$('#binfinte_partner input').prop('checked', 'checked');
						$('#binfinte_partner input').parent().addClass('ischecked');
					}*/
					_self.populateFlightBookingTitle();
				}
				else{
					$("#update-profile-failure").fadeIn();
				}
				
			},
			error:function(msg:any){
				console.log(msg);
			}
		});
	}

	redirectUser(msg:any) {
		if (msg.indexOf("timeout") > -1) {
			msg = msg.replace("timeout-","");
			window.location.href = msg;
		}
	}
	initcheckbox(): any {
		$('input[type="checkbox"]').click(function(){
            if($(this).prop("checked") == true){
				$(this).parent().addClass('ischecked')
            }
            else if($(this).prop("checked") == false){
                $(this).parent().removeClass('ischecked')
            }
		});
		$('#prefrence--checkbox-address').click(function(){
			if($(this).prop("checked") == true){
				$('#update-profile--preference-address-line-1').val($('#update-profile--personal-address-line-1').val());
				$('#update-profile--preference-address-postcode').val($('#update-profile--personal-address-postcode').val())
				$('#update-profile--preference-address-city').val($('#update-profile--personal-address-city').val());
				$('#update-profile--personal-prefcountries')[0].selectize.setValue($('#update-profile--personal-countries').val())
				$('#update-profile--personal-prefstates')[0].selectize.setValue($('#update-profile--personal-states').val())
            }
            else if($(this).prop("checked") == false){
				$('#update-profile--preference-address-line-1').val('');
				$('#update-profile--preference-address-city').val('');
				$('#update-profile--preference-address-postcode').val('')
				$('#update-profile--personal-prefcountries')[0].selectize.setValue('');
				$('#update-profile--personal-prefstates')[0].selectize.setValue('');
            }
		});
	}

	initSelectizeInputsnew(inputSelectArr:any): any {
		for (var i=0, len=inputSelectArr.length; i<len; i++) {
				let $this:any      = $(inputSelectArr[i]);
				let $thisLabel:any = $this.parent().find('label');
				$this.selectize({
					valueField: 'value',
					labelField: 'text',
					searchField: ['text'],
					selectOnTab: true,
					onInitialize: () => {
						$this[0].selectize.$control_input.attr('name', $this[0].selectize.$input[0].id.split('--')[1]);
						$this[0].selectize.$control_input.attr('data-parsley-errors-container', '#' + $this[0].selectize.$input[0].id + '--error-container');
					},
					onFocus: () =>  {
						$thisLabel.addClass('input-filled');
						$($this[0].selectize.$control[0]).addClass('select-filled');
					},
					onChange: () => {
						$thisLabel.addClass('input-filled');
						$($this[0].selectize.$control[0]).addClass('select-filled');
					},
					onBlur: () => {
						let $activeOptionChange:any = $this[0].selectize.getValue();
						
						if ($activeOptionChange == null || !$activeOptionChange.length) {
							$thisLabel.removeClass('input-filled');
							$($this[0].selectize.$control[0]).removeClass('select-filled');
						} else {
							$thisLabel.addClass('input-filled');
							$($this[0].selectize.$control[0]).addClass('select-filled');
						}
					},
				});
		}
	}
	initProgressBarElem(): any {
		var myElem = document.getElementsByClassName('member--gold');
		if(myElem.length > 0)
		{
		  $('#members--enrich-status-lcp .progress-bar').attr( "data-color","#efdfb4,#c8b06f");
		}	
		var myElem = document.getElementsByClassName('member--platinum');
		if(myElem.length > 0)
		{
		  $('#members--enrich-status-lcp .progress-bar').attr( "data-color","#ccd7e4,#506883");
		}	
		var myElem = document.getElementsByClassName('member--silver');
		if(myElem.length > 0)
		{
		  $('#members--enrich-status-lcp .progress-bar').attr( "data-color","#eeeff1,#aaadb0");
		}	
		var myElem = document.getElementsByClassName('member--blue');
		if(myElem.length > 0)
		{
		  $('#members--enrich-status-lcp .progress-bar').attr( "data-color","#a5e5f7,#00bff3");
		}	
		let DEFAULTS:any = {
			backgroundColor: '#b3cef6',
			progressColor: '#4b86db',
			percent: 0,
			duration: 2000,
			milestype: '',
			milespoints:'0',
			milestotal:'0'
		};	
		
		$('.progress-bar.position').each(function () {
			let $target:any  = $('.progress-bar.position');

			let opts:any = {
			backgroundColor: $target.data('color') ? $target.data('color').split(',')[0] : DEFAULTS.backgroundColor,
			progressColor: $target.data('color') ? $target.data('color').split(',')[1] : DEFAULTS.progressColor,
			percent: $target.data('percent') ? $target.data('percent') : DEFAULTS.percent,
			duration: $target.data('duration') ? $target.data('duration') : DEFAULTS.duration,
			milestype: $target.data('milestype') ? $target.data('milestype') : DEFAULTS.milestype,
			milespoints:$target.data('milespoints') ? $target.data('milespoints') : DEFAULTS.milespoints,
			milestotal:$target.data('milestotal') ? $target.data('milestotal') : DEFAULTS.milestotal,			
			};
			// console.log(opts);
	
			// $target.append('<div class="background"></div><div class="rotate"></div><div class="left"></div><div class="right"></div><div class=""><span>' + opts.percent + '</span></div>');
			$target.append('<div class="background"></div><div class="rotate"></div><div class="left"></div><div class="right"></div><div class=""><span><p class ="miles-points">' + opts.percent+'%' +'</p></span></div><p class="miles-name">Profile Completeness</p>');
	
			$target.find('.background').css('background', opts.backgroundColor);
			$target.find('.left').css('background-color', opts.backgroundColor);
			$target.find('.rotate').css('background-color', opts.progressColor);
			$target.find('.right').css('background-color', opts.progressColor);
	
			let $rotate:any = $target.find('.rotate');
			setTimeout(function () {	
				$rotate.css({
					'transition': 'transform ' + opts.duration + 'ms linear',
					'transform': 'rotate(' + opts.percent * 3.6 + 'deg)'
				});
			},1);		

			if (opts.percent > 50) {
				let animationRight:any = 'toggle ' + (opts.duration / opts.percent * 50) + 'ms step-end';
				let animationLeft:any = 'toggle ' + (opts.duration / opts.percent * 50) + 'ms step-start';  
				$target.find('.right').css({
					animation: animationRight,
					opacity: 1
				});
				$target.find('.left').css({
					animation: animationLeft,
					opacity: 0
				});
			} 
		});
	}

	headngContent():any
	{
		let _self=this;
		$('#tabs').on("click", "li", function (event:any) {         
			var activeTab = this.getAttribute('data-active-tab-name');
			switch (activeTab)
			{
				case 'personalDetail':
					$('.personal-tab--heading').removeClass('hide');
					$('.consent-tab--heading').addClass('hide');
					$('.preference-tab--heading').addClass('hide');
					$('.cobrand-tab--heading').addClass('hide');
					break;
				case 'consent':
					$('.personal-tab--heading').addClass('hide');;
					$('.consent-tab--heading').removeClass('hide');
					$('.preference-tab--heading').addClass('hide');;
					$('.cobrand-tab--heading').addClass('hide');;
					break;
				case 'preferences':
					$('.personal-tab--heading').addClass('hide');;
					$('.consent-tab--heading').addClass('hide');;
					$('.preference-tab--heading').removeClass('hide');
					$('.cobrand-tab--heading').addClass('hide');;
					break;
				case 'coBrand':
					$('.personal-tab--heading').addClass('hide');;
					$('.consent-tab--heading').addClass('hide');;
					$('.preference-tab--heading').addClass('hide');;
					$('.cobrand-tab--heading').removeClass('hide');
					break;
	
			}
			$('#update-profile-success').css({ 'display': 'none' });
			$('#update-profile-failure').css({ 'display': 'none' });
			_self.populateFields();
		  });
	}
	handleCountryStates(): any {
		let _self = this;
		let countryselect:any;
		var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

			countryselect = $('#update-profile--personal-countries');
		
		let listItems : any[]= [];
		countryselect.on("change", function(){
			$(".partner-state").fadeIn()
			let availableStates = $.grep(_self.statecodes.CountriesList,function(country:any, ind:any){
				return country.CountryCode ==countryselect.val()

			})
			let sel = $('#update-profile--personal-states')[0].selectize
			sel.clear()
			if(availableStates[0]){
				availableStates = availableStates[0].StatesList
				listItems=[]
				for(var i = 0; i<availableStates.length;i++){
					listItems[i] = {'text': availableStates[i].StateName, 'value': availableStates[i].StateCode}
				}
			}else{
				listItems = [{'text':'-',value:'NULL'}]
				sel.setValue("NULL")
				sel.setTextboxValue('-')
			}
			sel.clearOptions()
			sel.addOption(listItems)
			if(listItems.length===1){
				sel.setValue(listItems[0].value)
			}
			if ($("#update-profile--personal-states").val() == "NA") {
                $(".distance-padding-mobile.update-profile--personal-states").hide();
            }else{
                $(".distance-padding-mobile.update-profile--personal-states").show();
            }

		})
	}
	handleCountryStatesmob(): any {
		let _self = this;
		let countryselect:any;
		var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

			countryselect = $('#update-profile--personal-address-country');
		
		
		let listItems : any[]= [];
		countryselect.on("change", function(){
			$(".partner-state").fadeIn()
			let availableStates = $.grep(_self.statecodes.CountriesList,function(country:any, ind:any){
				return country.CountryCode ==countryselect.val()

			})
			let sel = $('#update-profile--personal-statesmob')[0].selectize
			sel.clear()
			if(availableStates[0]){
				availableStates = availableStates[0].StatesList
				listItems=[]
				for(var i = 0; i<availableStates.length;i++){
					listItems[i] = {'text': availableStates[i].StateName, 'value': availableStates[i].StateCode}
				}
			}else{
				listItems = [{'text':'-',value:'NULL'}]
				sel.setValue("NULL")
				sel.setTextboxValue('-')
			}
			sel.clearOptions()
			sel.addOption(listItems)
			if(listItems.length===1){
				sel.setValue(listItems[0].value)
			}
			if ($("#update-profile--personal-statesmob").val() == "NA") {
                $(".distance-padding-mobile.update-profile--personal-statesmob").hide();
            }else{
                $(".distance-padding-mobile.update-profile--personal-statesmob").show();
            }
		})
	}
	handleGender():any{

		let genderselect: any = $('#update-profile--gender')[0].selectize
		let titleselect: any = $('#update-profile--title');
		let data = [{'gender':'FEMALE','titles':"[{\"code\":\"Mrs\",\"name\":\"Mrs\"},{\"code\":\"Ms\",\"name\":\"Ms\"},{\"code\":\"Miss\",\"name\":\"Miss\"},{\"code\":\"Tun\",\"name\":\"Tun\"},{\"code\":\"Tan Sri\",\"name\":\"Tan Sri\"},{\"code\":\"Datuk\",\"name\":\"Datuk\"},{\"code\":\"Toh Puan \",\"name\":\"Toh Puan\"},{\"code\":\"Puan Sri\",\"name\":\"Puan Sri\"},{\"code\":\"Datin\",\"name\":\"Datin\"},{\"code\":\"Dato'\",\"name\":\"Dato'\"},{\"code\":\"Dato' Sri\",\"name\":\"Dato' Sri\"},{\"code\":\"Dato' Seri\",\"name\":\"Dato' Seri\"},{\"code\":\"Datuk Sri\",\"name\":\"Datuk Sri\"},{\"code\":\"Datuk Seri\",\"name\":\"Datuk Seri\"},{\"code\":\"Datin Sri\",\"name\":\"Datin Sri\"},{\"code\":\"Datin Seri\",\"name\":\"Datin Seri\"},{\"code\":\"YTM\",\"name\":\"YTM\"},{\"code\":\"DYMM\",\"name\":\"DYMM\"}]"},
		{'gender':'MALE','titles':"[{\"code\":\"Mr\",\"name\":\"Mr\"},{\"code\":\"Master\",\"name\":\"Master\"},{\"code\":\"Tun\",\"name\":\"Tun\"},{\"code\":\"Tan Sri\",\"name\":\"Tan Sri\"},{\"code\":\"Datuk\",\"name\":\"Datuk\"},{\"code\":\"Dato'\",\"name\":\"Dato'\"},{\"code\":\"Datuk Seri\",\"name\":\"Datuk Seri\"},{\"code\":\"Dato' Sri\",\"name\":\"Dato' Sri\"},{\"code\":\"Dato' Seri\",\"name\":\"Dato' Seri\"},{\"code\":\"Datuk Sri\",\"name\":\"Datuk Sri\"},{\"code\":\"YTM\",\"name\":\"YTM\"},{\"code\":\"DYMM\",\"name\":\"DYMM\"}]"}]
		let titlegendermapping = {}
			data.map(function(item:any){
				let gender = item.gender;
				let titles = JSON.parse(item.titles)
				for(let i = 0;i < titles.length;i++){
					
					if(titles[i].name in titlegendermapping){
						delete titlegendermapping[titles[i].name];
						continue;
					}
					titlegendermapping[titles[i].name] = gender
				 }
			})
			titleselect.on('change',function(){
				let selectedtitle = $(this).val()
				if( selectedtitle in titlegendermapping){
					let gender = titlegendermapping[selectedtitle]
					genderselect.setValue(gender)
					//Disable
					genderselect.disable()
					$('.update-profile--gender .selectize-input').css({
						'background': '#eee',
						'opacity': '1'
					});
					$('#update-profile--gender').prev().css({
						'background-color': '#eee',
						'border-top-left-radius':'10px',
						'border-top-right-radius': '10px'
					});
				}
				else{
					genderselect.enable()
					$('.update-profile--gender .selectize-input').css({
						'background': '#fff',
					});
					$('#update-profile--gender').prev().css({
						'background-color': '#fff',
						'border-top-left-radius':'0px',
						'border-top-right-radius': '0px'
					});
				}
				
			})
		
	} 
	handleDeleteAccount(){
		let _self = this;
		$('#delete-account-btn').click(function(){
			$.magnificPopup.open({
				items: {
					src: '#delete-account-popup'
			},
			type: 'inline',
			midClick: true,
			enableEscapeKey: false,
			showCloseBtn: false,
			closeOnBgClick: false,
			modal: false,
			callbacks: {
				open: function() {
					var $content = $(this.content);
					$content.on('touchmove', function(e:any){
						e.preventDefault();
					})
					$content.on('click', '.msg-btn-cancel', function() {
						$.magnificPopup.close();
					});
					$content.on('click', '.msg-btn-confirm', function() {
						$.magnificPopup.close();
					});
				}
			}
		}, 0);
		})
	}
	trackEvents() {
		let _self = this;
		function replaceTF(value :any) {
            if(value == undefined) {
                return  'N' 
            }
            else {
                return value === 'T' ? value.replace(/T/g, 'Y') : value.replace(/F/g, 'N');
            }           
        }
		let tabObj = {
			'personalDetail': 'personal-details',
			'consent': 'consent',
			'preferences': 'preferences',
			'coBrand': 'co-brand-cards'
		}
		let activeTabName: any = null;
		$('.update_tab li').click(function() {
			activeTabName = $(this).attr('data-active-tab-name');
			adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Personal Details',
                'clickName': 'click:tab-click:'+tabObj[activeTabName],
                'componentType': 'tab',
                'componentName': '',
                'componentID': '',
				'attributes': []
            });
		});
		$('#delete-account-btn').click(function () {
			adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Personal Details',
                'clickName': 'click:btn-click:delete-my-account',
                'componentType': 'btn',
                'componentName': '',
                'componentID': '',
				'attributes': []
            });
		});
		$('#claim-others-submit').click(function () {
			let clickname = null;
			let attributes: any = [];
			if (activeTabName == 'consent') {
				clickname = 'consent-update';
				attributes = [
					{
						'key': 'email',
						'value': 'enrich-'+replaceTF(_self.apiData.emailFromEnrich)+'|enrichpartner-'+replaceTF(_self.apiData.emailFromEnrichPartners)
					},
					{
						'key': 'sms',
						'value': 'enrich-'+replaceTF(_self.apiData.smsEnrich)+'|enrichpartner-'+replaceTF(_self.apiData.smsEnrichPartner)
					},
					{
						'key': 'phone',
						'value': 'enrich-'+replaceTF(_self.apiData.phoneEnrich)+'|enrichpartner-'+ replaceTF(_self.apiData.phoneEnrichPartner)
					},
					{
						'key': 'whatsApp',
						'value': 'enrich-'+replaceTF(_self.apiData.whatsAppFrmEnrich)+'|enrichpartner-'+ replaceTF(_self.apiData.whatsAppFrmPartner)
					},
					{
						'key': 'pushNotification',
						'value': 'enrich-'+replaceTF(_self.apiData.pushNotificationFrmEnrich)+'|enrichpartner-'+ replaceTF(_self.apiData.pushNotificationFrmPartner)
					},
				];

			} else if (activeTabName == 'preferences') {
				clickname = 'interests-update';
				attributes = [
					{
						'key': 'seating',
						'value': _self.apiData.preferedSeating
					},
					{ 
						'key': 'dietry',
						'value': _self.apiData.dietryRequirement
					},
					{ 
						'key': 'business',
						'value': replaceTF(_self.apiData.interestBusiness)
					},
					{ 
						'key': 'entertainment',
						'value': replaceTF(_self.apiData.interestEntertainment)
						
					},
					{ 
						'key': 'family',
						'value': replaceTF(_self.apiData.interestFamily)
					},
					{ 
						'key': 'fitness',
						'value': replaceTF(_self.apiData.interestFitness)
					},
					{
						'key': 'food',
						'value': replaceTF(_self.apiData.interestFood)
					},
					{ 
						'key': 'hobbies',
						'value': replaceTF(_self.apiData.interestHobbies)
					},
					{ 
						'key': 'shopping',
						'value': replaceTF(_self.apiData.interestShopping)
					},
					{ 
						'key': 'sports',
						'value': replaceTF(_self.apiData.interestSports)
					},
					{ 
						'key': 'technology',
						'value': replaceTF(_self.apiData.interestTech)
					},
					{ 
						'key': 'travel',
						'value': replaceTF(_self.apiData.interestTravel)
					},
				];
			}
			let clickEvent = {
                'pageName': '',
                'pageType': 'Enrich Profile - Personal Details',
                'clickName': 'click:btn-click:'+clickname,
                'componentType': 'btn',
                'componentName': '',
                'componentID': '',
				'attributes': attributes,
            }
			adobeDataLayer.push('click', clickEvent);
		})
	}
}

let scope:Element = document.querySelector('#update_profiles');

if (scope) {
	try {
	let memberupdateprofile = new memberUpdateProfile();
	var adobeDataLayer = new adobeDataLayerWrapper();
	memberupdateprofile.initTextInputs();
	memberupdateprofile.initSelectizeInputs();
	memberupdateprofile.PreinitSelectizeInputs();
	memberupdateprofile.initDatepickerInputs();
	memberupdateprofile.initPhoneInput();
	memberupdateprofile.initCheckboxes();	
	memberupdateprofile.initBusinessAddress();
	memberupdateprofile.validateForm();
	memberupdateprofile.populateFields();	
	memberupdateprofile.initcheckbox();
	memberupdateprofile.initPrintSaveCardLCP();
	memberupdateprofile.headngContent();
	memberupdateprofile.handleDeleteAccount();
	memberupdateprofile.trackEvents();
	adobeDataLayer.push('pageLoaded', {
        'pageName': '',
        'pageType': 'Enrich Profile - Personal Details',
		'attributes': []
    });
	} catch(e) {console.error(e);}
}